import { render, staticRenderFns } from "./GrapesEditor.vue?vue&type=template&id=66541b2b&"
import script from "./GrapesEditor.vue?vue&type=script&lang=js&"
export * from "./GrapesEditor.vue?vue&type=script&lang=js&"
import style0 from "./GrapesEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports